/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:26 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

import {InjectionToken} from '@angular/core' ;

export const PAKKK_EXCEPTIONTESTS_TOKEN = new InjectionToken<string>('PakkkExceptiontestsToken') ;